<template>
  <v-container fluid grid-list-lg>
    <v-form
      ref="form"
      lazy-validation
    >
      <v-layout row wrap>
        <v-flex x12 sm6 offset-sm3>
          <div class="boxHeader">
            Password requirements:
            <ul>
              <li>Must be eight characters or longer</li>
              <li>Must contain at least one upper case letter (A-Z)</li>
              <li>Must contain at least one lower case letter (a-z)</li>
              <li>Must contain at least one digit (0-9)</li>
            </ul>
          </div>
        </v-flex>
        <v-flex xs12 sm6 offset-sm3>
          <v-text-field
            label="Current Password"
            :type="showCurrentPassword ? 'text' : 'password'"
            v-model="current_password"
            :append-icon="showCurrentPassword ? 'visibility' : 'visibility_off'"
            @click:append="showCurrentPassword = !showCurrentPassword"
            box
            hide-details
            required
          />
        </v-flex>
        <v-flex xs12 sm6 offset-sm3>
          <v-text-field
            label="New Password"
            :type="showNewPassword ? 'text' : 'password'"
            v-model="new_password"
            :append-icon="showNewPassword ? 'visibility' : 'visibility_off'"
            @click:append="showNewPassword = !showNewPassword"
            box
            hide-details
            required
          />
        </v-flex>
        <v-flex xs12 sm6 offset-sm3>
          <v-text-field
            label="Confirm Password"
            :type="showConfirmPassword ? 'text' : 'password'"
            v-model="confirm_password"
            :append-icon="showConfirmPassword ? 'visibility' : 'visibility_off'"
            @click:append="showConfirmPassword = !showConfirmPassword"
            box
            hide-details
            required
          />
        </v-flex>
        <v-flex xs12 sm6 offset-sm3>
          <v-divider class="primary" />
        </v-flex>
      </v-layout>

      <v-layout row wrap align-center fill-height>
        <v-flex  xs12 sm6 offset-sm3>
          <v-layout row wrap justify-end>
            <v-btn color="primary" @click="change">change</v-btn>
          </v-layout>
        </v-flex>
      </v-layout>

    </v-form>
  </v-container>
</template>
<script>
import Bus from '@/bus'

import APIMixin from '@/mixins/api'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [APIMixin, StoreMixin],

  data: function () {
    return {
      current_password: '',
      new_password: '',
      confirm_password: '',
      showCurrentPassword: false,
      showNewPassword: false,
      showConfirmPassword: false
    }
  },

  methods: {
    async change () {
      try {
        await this.api({
          method: 'put',
          url: `/users/change_password`,
          data: this.$data
        })
        this.$store.commit('forceChangePassword', false)
        Bus.$emit('openModal', {
          status: 'info',
          message: 'Your password has been changed'
        })
        this.forceLogout()
        // this.$router.push('/')
      } catch (err) {
        console.log('ERROR')
        console.log(err)
        Bus.$emit('openModal', {
          status: 'error',
          message: err
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue